import useAppQuery from 'core/query-client/useAppQuery';
import { getBusinessUnits } from 'shared/api/business-units/http';

const useBusinessUnitsQuery = (options = {}) =>
  useAppQuery('business-units', getBusinessUnits, {
    ...options,
    cacheTime: Infinity,
    refetchOnMount: false
  });

export default useBusinessUnitsQuery;
